import pdf from '../../../assets/images/folders/pdf.png'
import video from '../../../assets/images/folders/single_video.svg'
import link from '../../../assets/images/folders/link.svg'
import file from '../../../assets/images/folders/file.svg'
import image from '../../../assets/images/folders/image.png'
import jpgimg from '../../../assets/images/folders/jpgimage.png'
import word from '../../../assets/images/folders/word.png'
import excel from '../../../assets/images/folders/excel.png'
import ppt from '../../../assets/images/folders/ppt.png'
import { API_URL } from '../../../config/constants'
const FILE_IMAGE_MAPPING = {
    'file': file,
    'video': video,
    'link': link,
    'jpg': jpgimg,
    'jpeg': jpgimg,
    'webp': jpgimg,
    'png': image,
    'pdf': pdf,
    'doc': word,
    'docx': word,
    'xls': excel,
    'xlsx': excel,
    'ppt': ppt,
    'pptx': ppt
}

export default function File ({file, type, onClick}) {
    return (
        <div className='file' onClick={onClick}>
            {
                type === 'file' ?
                    <img src={FILE_IMAGE_MAPPING[file?.filetype || 'file'] || FILE_IMAGE_MAPPING['file']} alt=""/>
                :
                    <img src={FILE_IMAGE_MAPPING[type || 'file']} alt=""/>
            }
            <span className='ms-2'>{file.name}</span>
        </div>
    )
}